import React from "react";
export default function SalesEcosystem(){
  return(
    <>
    <section className="sales-eco-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
             <h3 className="heading">Unified Connectivity Across Your Entire Sales Journey</h3>
            </div>
          <div className="col-lg-10">
            <div className="sales-eco-box">
            <img src="/assets/images/sales-company-logo.webp" alt="sales-company-logo" />
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}